// Automação de Envios texts (merged under the "campaign" key: t('campaign.campaigns.title')).
// "@" starts a linked message in vue-i18n: a literal one is written {'@'}.
export default {
  nav: 'Campanhas',
  sections: {
    results: 'Resultados',
    campaigns: 'Campanhas',
    contacts: 'Contatos',
    optouts: 'Descadastros',
    settings: 'Configurações',
  },
  common: {
    disabledTitle: 'Campanhas não disponíveis',
    disabledText: 'As Campanhas não estão ligadas para esta empresa. Fale com o suporte para ativar.',
    noAccessTitle: 'Acesso não liberado',
    noAccessText: 'O seu papel ainda não tem acesso às Campanhas. Peça a quem administra a empresa.',
    forbiddenTitle: 'Sem permissão',
    forbiddenText: 'O seu papel não permite abrir esta tela.',
    loadError: 'Não foi possível carregar.',
    noMatch: 'Nada encontrado com esses filtros.',
    search: 'Buscar',
    backToCampaign: 'Campanha',
    edit: 'Editar',
    delete: 'Excluir',
  },
  permissions: {
    group: 'Campanhas',
    groupHint: 'Campanhas e fluxos por e-mail e WhatsApp sobre os contatos do CRM.',
    envios_ver: 'Ver as Campanhas',
    envios_ver_hint: 'Vê todas as campanhas, segmentos, conteúdos, fluxos e o painel de resultados.',
    envios_editar: 'Criar e editar envios',
    envios_editar_hint: 'Cria segmentos, conteúdos, campanhas e fluxos; edita, pausa e exclui os que ela mesma criou.',
    envios_editar_todas: 'Editar envios de outras pessoas',
    envios_editar_todas_hint: 'Edita, pausa e exclui as campanhas criadas por qualquer pessoa (perfil de marketing).',
    envios_ativar: 'Ativar campanhas e fluxos',
    envios_ativar_hint: 'Ativa campanhas e fluxos. As criadas pelo assistente de IA só saem do rascunho por quem tem esta permissão.',
    envios_aprovar_ia: 'Aprovar textos gerados por IA',
    envios_aprovar_ia_hint: 'Aprova os textos gerados por IA antes de usá-los em uma campanha.',
    envios_exportar: 'Exportar relatórios de envio',
    envios_exportar_hint: 'Exporta os envios em CSV ou XLSX. Contém dados pessoais; cada exportação fica na auditoria.',
    envios_configurar: 'Configurar as Campanhas',
    envios_configurar_hint: 'Canais, remetentes, limites de envio e o marketing por WhatsApp da empresa.',
    ownerLocked: 'O dono tem todas as permissões das Campanhas.',
    changes: 'Campanhas: {items}',
    changesNone: 'sem permissões',
  },
  status: { draft: 'Rascunho', active: 'Ativa', paused: 'Pausada', ended: 'Encerrada' },
  channel: { email: 'E-mail', whatsapp: 'WhatsApp' },
  runStatus: { pending: 'Na fila', dispatching: 'Enviando', completed: 'Concluído', failed: 'Falhou', cancelled: 'Cancelado', missed: 'Perdido' },
  sendStatus: {
    queued: 'Na fila',
    sent: 'Enviada',
    delivered: 'Entregue',
    opened: 'Aberta',
    clicked: 'Clicou',
    replied: 'Respondeu',
    failed: 'Falhou',
    not_delivered: 'Não entregue',
    suppressed: 'Bloqueada',
    cancelled: 'Cancelada',
  },
  metrics: {
    sent: 'Enviados',
    delivered: 'Entregues',
    opened: 'Abertos',
    clicked: 'Clicados',
    replied: 'Respondidos',
    failed: 'Falhos',
    optOuts: 'Descadastros',
  },
  results: {
    title: 'Resultados dos envios',
    subtitle: 'Enviados, entregues, abertos, clicados, respondidos, falhos e descadastros, por campanha e por fluxo.',
    period: 'Período',
    lastDays: 'Últimos {n} dias',
    channel: 'Canal',
    campaignFilter: 'Campanhas',
    pickCampaign: 'Escolha ao menos uma campanha',
    pickCampaignText: 'Nenhuma campanha está marcada no filtro, então não há o que mostrar.',
    allCampaigns: 'Mostrar todas as campanhas',
    allChannels: 'Todos os canais',
    scope: 'De quem',
    everyone: 'Todas',
    mine: 'Só as minhas',
    ofAttempted: 'das tentativas',
    noSends: 'Nenhum envio neste período e canal',
    noSendsText: 'Quando uma campanha enviar, os números e o gráfico aparecem aqui.',
    noData: 'sem envios',
    sentPerDay: 'Envios por dia',
    campaigns: 'Por campanha',
    flows: 'Por fluxo',
    noCampaigns: 'Nenhuma campanha enviou neste período.',
    noFlows: 'Nenhum fluxo enviou neste período.',
    columns: { name: 'Nome', channel: 'Canal', inside: 'Dentro agora' },
  },
  campaigns: {
    title: 'Campanhas',
    subtitle: 'Um conteúdo enviado a um segmento, uma vez ou de forma recorrente. Todos veem todas; só quem criou (ou o marketing) altera.',
    new: 'Nova campanha',
    edit: 'Editar campanha',
    filterAll: 'Todas',
    onlyMine: 'Só as minhas',
    emptyTitle: 'Nenhuma campanha ainda',
    emptyText: 'Crie um segmento e um conteúdo e monte a primeira campanha.',
    columns: { name: 'Nome', status: 'Situação', channel: 'Canal', segment: 'Segmento', schedule: 'Agenda', next: 'Próximo disparo', sent: 'Enviados', creator: 'Criada por' },
    fields: { name: 'Nome', channel: 'Canal', segment: 'Segmento', template: 'Conteúdo', schedule: 'Agenda' },
    pickSegment: 'Escolha o segmento',
    pickTemplate: 'Escolha o conteúdo',
    saved: 'Campanha salva.',
    created: 'Rascunho criado. Revise e ative quando estiver pronta.',
    activate: 'Ativar',
    resume: 'Retomar',
    pause: 'Pausar',
    test: 'Enviar teste',
    duplicate: 'Duplicar',
    end: 'Encerrar',
    nextRun: 'Próximo disparo: {when}',
    byAssistant: 'Criada pelo assistente',
    resumesAt: 'Volta sozinha em {when}.',
    segment: 'Segmento',
    template: 'Conteúdo',
    testSent: 'Teste enviado para {address}.',
    confirmEnd: 'Encerrar esta campanha? O que estava na fila não será enviado e ela não poderá ser reativada.',
    confirmDelete: 'Excluir este rascunho?',
    done: { activate: 'Campanha ativada.', pause: 'Campanha pausada.', resume: 'Campanha retomada.', end: 'Campanha encerrada.' },
    runs: {
      title: 'Disparos',
      empty: 'Ainda não houve nenhum disparo.',
      when: 'Disparo',
      status: 'Situação',
      recipients: 'Destinatários',
    },
  },
  schedule: {
    kindLabel: 'Repetição',
    kind: { once: 'Uma vez', daily: 'Todos os dias', weekly: 'Dias da semana', monthly: 'Um dia do mês' },
    time: 'Horário',
    zoneLabel: 'Fuso horário',
    zone: {
      America_Sao_Paulo: 'Brasília (padrão)',
      America_Manaus: 'Manaus',
      America_Cuiaba: 'Cuiabá',
      America_Rio_Branco: 'Rio Branco',
      America_Noronha: 'Fernando de Noronha',
      UTC: 'UTC',
    },
    date: 'Data',
    dayOfMonth: 'Dia do mês',
    dayOfMonthHint: 'Em meses mais curtos, vale o último dia.',
    startsOn: 'Começa em',
    endsOn: 'Termina em',
    endsOnHint: 'Em branco = sem fim.',
    days: 'Dias da semana',
    day: { monday: 'Segunda', tuesday: 'Terça', wednesday: 'Quarta', thursday: 'Quinta', friday: 'Sexta', saturday: 'Sábado', sunday: 'Domingo' },
    upcoming: 'Próximos disparos',
    invalid: 'A agenda não está completa.',
    none: 'Nenhuma data futura.',
  },
  triggers: {
    title: 'Fluxos a partir desta campanha',
    hint: 'Quem interagir com a mensagem entra em um fluxo (um por tipo de interação).',
    none: 'Nenhum',
    kind: { opened: 'Quem abriu', clicked: 'Quem clicou em um link', replied: 'Quem respondeu', no_interaction: 'Quem não interagiu' },
    days: 'Dias',
    daysSuffix: 'dias depois da mensagem',
    afterDays: '{n} dias',
    save: 'Salvar gatilhos',
    saved: 'Gatilhos salvos.',
    openedWarning: 'Atenção: leitores de e-mail com proteção de privacidade (como o Apple Mail) abrem as mensagens sozinhos, então as aberturas podem estar infladas e quem não leu também pode entrar no fluxo.',
  },
  segments: {
    emptyRuleWarning: 'Sem nenhum critério, todos os contatos do CRM entram na campanha. Adicione pelo menos uma condição.',
    title: 'Segmentos',
    subtitle: 'Quem recebe uma campanha: uma regra sobre os contatos do CRM, calculada na hora de cada disparo.',
    new: 'Novo segmento',
    edit: 'Segmento',
    emptyTitle: 'Nenhum segmento ainda',
    emptyText: 'Ex.: empresas de São Paulo no segmento de tecnologia.',
    columns: { name: 'Nome', description: 'Descrição', usedBy: 'Campanhas que usam', creator: 'Criado por', updated: 'Atualizado' },
    fields: { name: 'Nome', description: 'Descrição' },
    saved: 'Segmento salvo.',
    confirmDelete: 'Excluir o segmento {name}?',
    and: 'Todas (E)',
    or: 'Qualquer uma (OU)',
    group: 'Grupo ( … )',
    date: 'Data',
    businessDays: 'Dias úteis',
    businessDaysHint: 'Segunda a sexta, sem feriados. Sem nenhum contato registrado conta como muito tempo.',
    enums: {
      stage: { prospect: 'Prospect (sem proposta)', negotiating: 'Em negociação', customer: 'Cliente' },
      contact_type: { lead: 'Lead (ainda não é cliente)', customer: 'Cliente' },
      relationship: { low: 'Baixo', medium: 'Médio', high: 'Alto' },
      potential: { low: 'Baixo', medium: 'Médio', high: 'Alto' },
    },
    groupHint: 'Para encadear, adicione um grupo: dentro dele você escolhe se vale todas (E) ou qualquer uma (OU) das condições. Ex.: UF = SC E (tipo = lead OU cadastro até 01/01/2026).',
    combinator: 'Combinar condições',
    field: 'Campo',
    operator: 'Operador',
    value: 'Valor',
    values: 'Valores',
    valuesHint: 'Separe por vírgula. Ex.: {examples}',
    listHint: 'Separe por vírgula.',
    noConditions: 'Sem condições, o segmento alcança todos os contatos do CRM.',
    addCondition: 'Adicionar condição',
    addGroup: 'Adicionar grupo',
    removeCondition: 'Remover condição',
    removeGroup: 'Remover grupo',
    preview: 'Prévia',
    reaches: 'Alcança {n} contatos',
    estimated: 'estimativa',
    channelCounts: 'Podem receber: {email} por e-mail e {whatsapp} por WhatsApp; {out} descadastrados.',
    previewError: 'Não foi possível calcular a prévia.',
  },
  templates: {
    title: 'Conteúdos',
    subtitle: 'As mensagens de e-mail e WhatsApp, com variáveis, anexos e sugestões de texto por IA.',
    new: 'Novo conteúdo',
    edit: 'Conteúdo',
    filterAll: 'Todos',
    emptyTitle: 'Nenhum conteúdo ainda',
    emptyText: 'Escreva a mensagem uma vez e use em quantas campanhas quiser.',
    awaitingApproval: 'Aguardando aprovação',
    aiApproved: 'IA aprovado',
    columns: { name: 'Nome', channel: 'Canal', subject: 'Assunto', status: 'Situação', creator: 'Criado por', updated: 'Atualizado' },
    fields: { name: 'Nome', channel: 'Canal', subject: 'Assunto', body: 'Texto' },
    variables: 'Variáveis',
    useBlocks: 'Montar por blocos',
    insertVariable: 'Inserir variável:',
    insertVariableHint: 'Clique no campo onde quer a variável (assunto, texto, bloco) e depois na variável: ela entra onde está o cursor.',
    createAndClose: 'Salvar conteúdo',
    saved: 'Conteúdo salvo.',
    ai: {
      title: 'Sugestão de texto por IA',
      objective: 'Objetivo da mensagem',
      objectivePlaceholder: 'Ex.: convidar clientes para o webinar de novembro',
      tone: 'Tom (opcional)',
      tonePlaceholder: 'Ex.: formal, próximo, direto',
      suggest: 'Sugerir texto',
      applied: 'Sugestão aplicada. Revise antes de salvar: o texto gerado por IA precisa ser aprovado antes de ir para uma campanha.',
      waiting: 'Este texto foi gerado por IA e ainda não foi aprovado: não pode ser usado em uma campanha ativa.',
      approve: 'Aprovar texto',
      approvedToast: 'Texto aprovado.',
      reviewTitle: 'Texto sugerido por IA',
      approveOnSave: 'Li o texto e aprovo o uso em campanhas',
      approveOnSaveHint: 'O texto gerado por IA só pode ir para uma campanha ativa depois de aprovado por uma pessoa.',
      askApprover: 'O texto foi sugerido por IA. Depois de salvar, peça a quem tem a permissão de aprovar para liberá-lo nas campanhas.',
    },
    blocks: {
      text: 'Texto',
      image: 'Imagem',
      button: 'Botão',
      divider: 'Divisor',
      spacer: 'Espaço',
      heading: 'Usar como título',
      buttonLabel: 'Texto do botão',
      buttonDefault: 'Saiba mais',
      url: 'Endereço do link',
      alt: 'Texto alternativo',
      height: 'Altura (px)',
      up: 'Subir',
      down: 'Descer',
    },
    attachments: {
      title: 'Anexos',
      hint: 'PDF, JPG ou PNG de até 10 MB. As imagens podem ir dentro do e-mail; os PDFs vão anexados.',
      hintWhatsapp: 'No WhatsApp vai um arquivo por mensagem, enviado como arquivo (PDF ou imagem de até 10 MB).',
      drop: 'Solte um arquivo aqui ou escolha',
    },
    defaults: {
      title: 'Texto quando o contato não tem a informação',
      hint: 'Para cada variável usada na mensagem, escreva o texto que vale quando o contato não tem essa informação. Sem isso, a mensagem sai incompleta para ele.',
      none: 'A mensagem ainda não usa variáveis.',
      placeholder: 'Ex.: cliente',
      variable: 'Variável (sem chaves)',
      value: 'Texto',
      add: 'Adicionar',
    },
    preview: {
      title: 'Prévia',
      sample: 'Com uma pessoa de exemplo.',
      contact: 'Com os dados de {name}.',
      missing: 'Sem valor para: {list}.',
      empty: 'Escreva o texto para ver a prévia.',
    },
  },
  meta: {
    title: 'Modelo da Meta (WhatsApp oficial)',
    hint: 'Na API oficial só vai mensagem de modelo aprovado pela Meta. Envie o texto para aprovação e acompanhe aqui.',
    status: { none: 'Não enviado', pending: 'Em análise', approved: 'Aprovado', rejected: 'Rejeitado' },
    onSave: 'Enviar para aprovação da Meta ao salvar',
    onSaveHint: 'O modelo vai para análise logo depois de salvo; o acompanhamento aparece ao abrir o conteúdo.',
    name: 'Nome do modelo',
    nameHint: 'Só letras minúsculas, números e sublinhado.',
    language: 'Idioma',
    category: 'Categoria',
    marketing: 'Marketing',
    utility: 'Utilidade',
    submit: 'Enviar para aprovação',
    refresh: 'Atualizar situação',
    submitted: 'Modelo enviado à Meta.',
  },
  flows: {
    title: 'Campanhas',
    subtitle: 'Cada campanha tem o seu fluxo de mensagens, o seu segmento (quem entra) e os seus contatos.',
    new: 'Nova campanha',
    edit: 'Editar campanha',
    filterAll: 'Todas',
    emptyTitle: 'Nenhuma campanha ainda',
    emptyText: 'Ex.: todo dia às 9h, quem for de São Paulo e ainda não recebeu entra e ganha um e-mail, uma espera de 3 dias e um lembrete.',
    columns: { name: 'Nome', status: 'Situação', steps: 'Etapas', segment: 'Segmento', schedule: 'Entrada de contatos', inside: 'Dentro agora', completed: 'Concluíram', created: 'Criada' },
    tabs: { flow: 'Fluxo', segment: 'Segmento', content: 'Conteúdos', contacts: 'Contatos', sends: 'Envios', exports: 'Exportações', label: 'Partes da campanha' },
    content: {
      title: 'Conteúdos desta campanha',
      text: 'As mensagens que as etapas de envio usam. Para trocar o conteúdo de uma etapa, edite a campanha.',
      empty: 'Nenhuma etapa de envio tem conteúdo ainda',
      emptyText: 'Escolha o conteúdo em cada etapa de envio, ao editar a campanha, ou crie um aqui.',
      new: 'Novo conteúdo',
      library: 'Biblioteca de conteúdos',
      usedIn: 'Usado em',
      columns: { name: 'Conteúdo', channel: 'Canal', steps: 'Etapas' },
    },
    contactsBase: 'Base de contatos, importações e descadastros',
    wizard: {
      label: 'Passos da campanha',
      steps: { basics: 'Básico', segment: 'Quem entra', schedule: 'Quando', flow: 'Fluxo', review: 'Revisar' },
      titles: { basics: 'Como vai se chamar a campanha?', segment: 'Quem entra nesta campanha?', schedule: 'Quando os contatos entram?', flow: 'O que cada contato recebe?', review: 'Revise e salve' },
      hints: {
        basics: 'Dê um nome. Se já existe uma campanha parecida, copie o fluxo e o segmento dela e ajuste.',
        segment: 'Defina os critérios: quem atende a eles entra na campanha, uma vez cada.',
        schedule: 'Escolha o dia e o horário em que os contatos novos entram na campanha.',
        flow: 'Monte as etapas: mensagens, esperas e condições. Clique no + para encadear a próxima etapa.',
        review: 'Confira o resumo. Você pode salvar como rascunho ou salvar e já ativar.',
      },
      nameRequired: 'Dê um nome à campanha.',
      next: 'Continuar',
      back: 'Voltar',
      done: 'Concluído',
      saveDraft: 'Salvar rascunho',
      saveActivate: 'Salvar e ativar',
      everyone: 'Todos os contatos do CRM (nenhum critério)',
      rule: '{n} critério(s)',
      stepCount: '{n} etapa(s)',
      checkTitle: 'Antes de ativar',
      fix: 'Corrigir',
      noContent: 'Ainda não há conteúdo para este canal. Crie um em Conteúdos, dentro da campanha, depois de salvar.',
      check: {
        name: 'A campanha tem nome',
        segment: 'O segmento tem pelo menos um critério',
        steps: 'O fluxo tem pelo menos uma etapa',
        content: 'Todas as etapas de envio têm conteúdo',
        reach: 'Todas as etapas são alcançadas a partir da primeira',
        ends: 'Todo caminho termina em um Fim',
        endResult: 'Todo Fim tem um resultado',
      },
    },
    copy: {
      title: 'Copiar de outra campanha',
      text: 'Traz o fluxo (etapas e posições) e o segmento (os filtros) de outra campanha. A cópia é independente: mudar uma não muda a outra.',
      pick: 'Escolha a campanha',
      parts: 'O que copiar',
      flow: 'O fluxo',
      segment: 'O segmento',
      action: 'Copiar',
      confirmTitle: 'Substituir as etapas e o segmento atuais pelos da campanha escolhida? Só vale depois de salvar.',
      done: 'Copiado de "{name}". Revise e salve.',
      failed: 'Não foi possível copiar essa campanha.',
      none: 'Não há outra campanha para copiar.',
    },
    segmentTitle: 'Segmento: quem entra',
    segmentText: 'Os contatos do CRM que atendem a estes critérios entram na campanha, uma vez cada.',
    segmentOnlyHere: 'Mudar o segmento vale para esta campanha; as outras não são afetadas.',
    fields: {
      name: 'Nome',
      description: 'Descrição',
      start: 'Primeira etapa',
      exitOnReply: 'Sair da campanha ao responder',
      exitOnReplyHint: 'Quem responde deixa de receber as mensagens automáticas.',
      label: 'Nome da etapa',
      type: 'Tipo',
      channel: 'Canal',
      template: 'Conteúdo',
      wait: 'Esperar',
      unit: 'Unidade',
      condition: 'Se o contato',
      yes: 'Se sim, vai para',
      no: 'Se não, vai para',
      next: 'Depois vai para',
      interruptOn: 'Terminar a espera antes se o contato',
      interruptOnHint: 'Escolha o que o contato pode fazer com a última mensagem para sair da espera na hora, sem esperar o tempo acabar.',
      interacted: 'Se interagir, vai para',
      timeout: 'Se o tempo acabar, vai para',
      endName: 'Nome do fim',
      endResult: 'Resultado',
      endConverts: 'Transformar em cliente',
      endConvertsHint: 'Se o contato for um lead (importado por planilha, ainda fora do CRM), a empresa dele passa a ser cliente e aparece em Clientes assim que chega a este fim. Quem já é cliente não muda.',
      endResultHint: 'O que aconteceu com o contato. Fica salvo para cada contato que chega aqui e alimenta os resultados. Ex.: Abriu o acompanhamento, mas não respondeu a pergunta.',
    },
    type: { send: 'Enviar mensagem', wait: 'Aguardar', condition: 'Condição', end: 'Fim' },
    add: { send: 'Enviar mensagem', wait: 'Aguardar', condition: 'Condição', end: 'Fim (resultado)' },
    interrupt: { none: 'Só esperar o tempo (sem interromper)', clicked: 'Clicar em um link', opened: 'Abrir', replied: 'Responder' },
    condition: { replied: 'Respondeu', clicked: 'Clicou em um link', opened: 'Abriu', opened_no_reply: 'Abriu e não respondeu', clicked_no_reply: 'Clicou e não respondeu', opened_no_click: 'Abriu e não clicou' },
    unit: { minutes: 'minutos', hours: 'horas', days: 'dias' },
    firstStep: 'Comece adicionando a primeira etapa: uma mensagem, uma espera ou uma condição.',
    pickTemplate: 'Escolha o conteúdo',
    newContent: {
      open: 'Novo conteúdo',
      save: 'Criar e usar',
      created: 'Conteúdo criado e escolhido para esta etapa.',
      hint: 'Texto simples. Para variáveis, blocos, anexos e IA, edite depois em Conteúdos.',
    },
    endsHere: 'Sem destino (escolha uma etapa ou um Fim)',
    locked: 'Pause a campanha para editá-la.',
    saved: 'Campanha salva.',
    valid: 'A campanha está pronta para ser ativada.',
    validate: 'Verificar',
    activate: 'Ativar',
    resume: 'Retomar',
    pause: 'Pausar',
    end: 'Encerrar',
    duplicate: 'Duplicar',
    confirmEnd: 'Encerrar esta campanha? Todos que estão dentro saem e o que estava na fila não será enviado.',
    confirmDelete: 'Excluir este rascunho?',
    confirmDeleteUsed: 'Excluir esta campanha? Os contatos que estão nela saem, o que estava na fila não será enviado e a campanha some das listas e dos resultados. Os envios que já saíram continuam registrados e contam para o limite de frequência de cada contato. Não dá para desfazer.',
    done: { activate: 'Campanha ativada.', pause: 'Campanha pausada.', end: 'Campanha encerrada.' },
    exitsOnReply: 'Sai ao responder',
    staysOnReply: 'Continua mesmo se responder',
    counts: { active: 'Dentro agora', completed: 'Concluíram', exited: 'Saíram' },
    exitReason: { replied: 'Saíram por resposta', opted_out: 'Saíram por descadastro', flow_ended: 'Campanha encerrada', step_removed: 'Etapa removida', contact_removed: 'Contato removido' },
    stepsTitle: 'Etapas',
    sender: {
      title: 'Quem envia os e-mails',
      text: 'O e-mail sai com o nome do usuário e as respostas vão para o e-mail dele. O endereço de envio continua o da instituição.',
      mode: 'Remetente',
      modes: { institution: 'A instituição (padrão)', fixed: 'Um usuário fixo', consultant: 'O consultor responsável pelo cliente' },
      person: 'Usuário',
      fallback: 'Se o cliente não tiver consultor, enviar como',
      fallbackHint: 'Também vale quando o consultor não tem usuário vinculado (Funcionários › Acesso ao sistema) ou o usuário não tem e-mail.',
      choose: 'Escolha um usuário',
      noEmail: 'sem e-mail',
      whatsapp: 'Só vale para e-mail. O WhatsApp continua saindo pelo número da instituição.',
      lineInstitution: 'A instituição',
      lineFixed: '{name}',
      lineConsultant: 'Consultor do cliente · se não houver, {name}',
    },
    entry: {
      title: 'Quando os contatos entram na campanha',
      text: 'No dia e horário escolhidos, os contatos do segmento que ainda não estão na campanha entram e começam pela primeira etapa.',
      enable: 'Começar por um agendamento',
      enableHint: 'Todo dia (ou nos dias escolhidos), num horário, os contatos que atendem aos critérios do segmento entram na campanha.',
      segment: 'Segmento (os critérios)',
      pickSegment: 'Escolha um segmento',
      schedule: 'Quando entram',
      firstRun: 'Na primeira vez entram todos os contatos que já atendem aos critérios; depois, só os que passarem a atender.',
      reentry: 'Quem já passou pela campanha pode voltar',
      reentryAfter: 'Voltar depois de (dias)',
      reentryHint: 'Desligado: cada contato entra uma única vez na campanha.',
      node: 'Entrada pelo segmento "{segment}"',
      nodeOwn: 'Entrada pelo segmento da campanha',
      line: '{when}: os contatos do segmento "{segment}" que ainda não estão na campanha entram nela e seguem o fluxo a partir da primeira etapa (se for um envio, a mensagem sai em seguida).',
      next: 'Próxima entrada: {at}',
      last: 'Última entrada: {at}',
      never: 'ainda não houve',
      runNow: 'Iniciar envio agora',
      runNowHint: 'Não quer esperar o horário? "Iniciar envio agora" coloca na campanha, já, os contatos do segmento que ainda não entraram, e a primeira etapa roda em seguida.',
      runNowTitle: 'Iniciar o envio agora?',
      runNowText: 'Os contatos do segmento "{segment}" que ainda não estão na campanha entram agora e seguem o fluxo a partir da primeira etapa. Se a primeira etapa é um envio, as mensagens começam a sair em instantes (respeitando descadastros e os limites de envio). Quem já está na campanha não recebe de novo.',
      runNowKeep: 'O agendamento não muda: a próxima entrada continua em {at}.',
      runNowConfirm: 'Iniciar envio',
      runNowDone: 'Os contatos estão entrando na campanha. A primeira etapa roda em instantes.',
      reentryLine: 'Quem já passou pode voltar depois de {n} dia(s).',
      onceLine: 'Cada contato entra uma única vez.',
    },
    graph: { yes: 'Sim', no: 'Não', trigger: 'Início: campanha', label: 'Desenho do fluxo, da campanha que o inicia até a última etapa', view: 'Ver como', asGraph: 'Grafo', asList: 'Lista', hint: 'Clique numa campanha para abri-la.', entry: 'Início agendado',
      addStep: 'Adicionar etapa',
      duplicate: 'Duplicar etapa',
      zoomIn: 'Aumentar o zoom',
      zoomOut: 'Diminuir o zoom',
      zoomReset: 'Zoom 100%',
      arrange: 'Organizar',
      arrangeHint: 'Volta as etapas para a organização automática',
      addAfter: 'Adicionar depois desta etapa',
      makeStart: 'Começar por esta',
      isStart: 'Primeira etapa',
      pickStep: 'Clique numa etapa do desenho para editá-la aqui, ou adicione uma etapa pelos botões acima.',
      noTemplate: 'sem conteúdo',
      noResult: 'sem resultado',
      becomesCustomer: 'vira cliente',
      orWhen: 'ou ao {what}',
      wait_yes: 'Interagiu',
      wait_next: 'Tempo',
      expand: 'Ampliar o desenho',
      shrink: 'Voltar ao tamanho normal',
      editStep: 'Editar etapa',
      addNext: 'Adicionar a próxima etapa',
      controls: 'Controles do desenho',
      fit: 'Ajustar à tela', removeLine: 'Clique para remover esta ligação', connect: 'Arraste até outra etapa para ligar', editHint: 'Arraste as etapas para organizar. Duplo clique edita a etapa. Arraste o círculo da direita até outra etapa para ligá-las, ou clique no + para criar a próxima. Clique numa linha para desligar. Ctrl+C / Ctrl+V copia, Delete exclui, Ctrl + roda do mouse dá zoom.', canvas: 'Desenho do fluxo' },
    startedBy: 'Esta campanha começa quando…',
    notStarted: 'Ninguém entra nesta campanha ainda. Edite a campanha, escolha o segmento e agende o dia e o horário em que os contatos entram.',
    review: {
      whoTitle: 'Quem entra',
      contacts: 'contatos',
      customers: 'clientes',
      byEmail: 'podem receber por e-mail',
      byWhatsapp: 'podem receber por WhatsApp',
      customersHint: 'Um cliente (empresa) pode ter mais de um contato: cada contato entra uma vez e recebe as mensagens.',
      estimated: 'Os números são uma estimativa (a prévia olha até um limite de contatos).',
      flowTitle: 'O que o fluxo faz',
      noEnds: 'O fluxo ainda não tem nenhum Fim alcançado. Todo caminho precisa terminar em um Fim.',
      total: 'Cada contato leva {time} para terminar o fluxo (soma das esperas).',
      end: 'Fim',
      result: 'Resultado',
      steps: 'Passos',
      time: 'Demora',
      paths: 'Ver os caminhos ({n})',
      pathLine: '{steps} passo(s), {time}',
      truncated: 'Mostrando só os primeiros caminhos.',
    },
    here: '{n} aqui',
    sentOpened: '{sent} enviadas, {opened} abertas, {replied} respondidas',
    days: '{n} dia(s)',
    hours: '{n} hora(s)',
    minutes: '{n} minuto(s)',
    nextTo: 'Depois: {to}',
    yesTo: 'Se sim: {to}',
    noTo: 'Se não: {to}',
    contactsTitle: 'Contatos',
    contactSearch: 'Buscar contato',
    contactSearchHint: 'Nome, cliente ou e-mail',
    allEnds: 'Todos os fins',
    endContacts: '{n} contato(s) terminaram aqui',
    where: {
      active: 'Está agora em: {step}',
      completed: 'Terminou em "{end}": {result}',
      exited: 'Saiu do fluxo: {reason}',
      entered: 'Entrou em {at}',
      finished: 'terminou em {at}',
      replied: 'Respondeu em {at}',
    },
    noContacts: 'Nenhum contato neste filtro.',
    allSteps: 'Todas as etapas',
    allStatus: 'Todas as situações',
    enrollment: { active: 'Dentro', completed: 'Concluiu', exited: 'Saiu' },
    contacts: { end: 'Fim', result: 'Resultado', email: 'E-mail', name: 'Contato', company: 'Empresa', status: 'Situação', step: 'Etapa', entered: 'Entrou em', replied: 'Respondeu em', left: 'Por que saiu', source: 'Veio da campanha' },
  },
  contacts: {
    title: 'Contatos',
    subtitle: 'As pessoas do CRM, de onde vieram e se podem receber cada canal. Dados pessoais: cada consulta fica na auditoria.',
    tabs: { contacts: 'Contatos', imports: 'Importações' },
    searchPlaceholder: 'Nome, empresa, e-mail ou telefone',
    emptyTitle: 'Nenhum contato encontrado',
    emptyText: 'Os contatos vêm do CRM do ERP. Importe uma planilha para cadastrar novos como leads (eles só aparecem em Clientes quando viram clientes).',
    total: '{n} contatos',
    columns: { name: 'Contato', company: 'Empresa', type: 'Tipo', email: 'E-mail', phone: 'Telefone', emailState: 'Recebe e-mail', whatsappState: 'Recebe WhatsApp', origin: 'Origem', city: 'Cidade', lastSent: 'Último envio' },
    filters: {
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      origin: 'Origem',
      lastSentFrom: 'Último envio de',
      lastSentTo: 'Último envio até',
      lastSentMode: 'Último envio há',
      days: 'Dias',
      neverSent: 'Nunca enviado',
      modes: { over: 'Mais de N dias (ou nunca)', under: 'Menos de N dias', upto: 'Até N dias', never: 'Nunca recebeu envio' },
    },
    lead: 'Lead',
    customer: 'Cliente',
    convert: 'Transformar em cliente',
    convertConfirm: 'Transformar {name} em cliente?',
    convertDone: 'Pronto: a empresa agora é cliente e aparece em Clientes, no CRM.',
    convertAlready: 'Esta empresa já era cliente.',
    state: { ready: 'Pode receber', opted_out: 'Descadastrado', missing: 'Sem endereço', invalid: 'Inválido' },
    origin: { crm: 'CRM', spreadsheet: 'Planilha' },
    legalBasis: 'Base legal: {basis}',
    history: 'Histórico',
    noHistory: 'Nada foi enviado a este contato ainda.',
    reply: 'Resposta do contato',
    flowMessage: 'Mensagem de fluxo',
  },
  imports: {
    title: 'Importar contatos',
    new: 'Importar contatos',
    started: 'Importação iniciada.',
    intro: 'Envie uma planilha CSV ou XLSX. Quem ainda não existir no CRM entra como lead (não aparece em Clientes até virar cliente); quem já existe só tem o que faltava completado.',
    basisLabel: 'Base legal desta lista',
    basisChoose: 'Escolha a base legal…',
    basisHint: 'Por que a empresa pode falar com essas pessoas (LGPD). Fica registrado em cada contato.',
    basisHelp: {
      consent: 'Só marque se cada pessoa autorizou receber comunicação comercial e você consegue provar (onde, quando e o texto). Sem prova, não use.',
      legitimate_interest: 'Para quem já tem relação com a empresa, como ex-clientes, e espera ser contatado. Guarde por escrito a avaliação do legítimo interesse e respeite todo pedido de descadastro.',
      contract: 'Só para quem tem contrato em vigor e o contato é parte dele. Depois que o contrato acabou, não serve.',
    },
    originLabel: 'Origem dos contatos',
    originHint: 'De onde vem esta lista (ex.: Feira 2026, Indicações). Já vem com o nome do arquivo; troque se quiser. Aparece em Contatos › Origem.',
    basisFirst:'A primeira base legal registrada para um contato não é trocada por listas seguintes. Se a sua planilha mistura públicos, importe uma planilha para cada base.',
    chooseBasisFirst: 'Escolha a base legal para liberar o envio da planilha.',
    checkFirst: 'Conferir antes de importar',
    back: 'Voltar ao mapeamento',
    previewIntro: '{name}: o que vai acontecer com as {n} linhas.',
    preview: {
      newLeads: 'novos leads, que entram só em Campanhas até virarem clientes',
      existingLeads: 'já eram leads, só ganham o que faltava',
      existingCustomers: 'já são clientes do CRM, continuam clientes e só ganham o contato',
      reviews: 'para revisar, nada é alterado neles (conflito de dados)',
      rejected: 'rejeitadas, não dá para usar',
      tag: { review: 'Revisar', rejected: 'Rejeitada' },
      problems: 'O que precisa de atenção',
      line: 'Linha {n} da planilha',
      estimated: 'A planilha é grande: duas linhas da mesma empresa nova em blocos diferentes podem ser contadas como duas.',
      untouched: 'Nada foi gravado ainda. Só começa quando você clicar em Iniciar importação.',
    },
    basis: { consent: 'Consentimento', legitimate_interest: 'Legítimo interesse', contract: 'Execução de contrato' },
    drop: 'Solte a planilha aqui ou escolha (até 20 MB)',
    sampleLink: 'Baixar planilha de exemplo',
    sampleHint: '(CSV, abre no Excel). Precisa de empresa ou nome, e de e-mail ou telefone; as outras colunas são opcionais.',
    sampleFile: 'contatos-exemplo.csv',
    rows: '{name}: {n} linhas. Ligue cada coluna a um campo do contato.',
    connectTo: 'Campo do contato',
    ignore: 'Ignorar esta coluna',
    start: 'Iniciar importação',
    field: {
      company: 'Empresa',
      contact: 'Nome do contato',
      role: 'Cargo',
      email: 'E-mail',
      phone: 'Telefone',
      cnpj: 'CNPJ',
      postalCode: 'CEP',
      state: 'UF',
      city: 'Cidade',
      segment: 'Segmento',
    },
    emptyTitle: 'Nenhuma importação ainda',
    emptyText: 'Importe uma lista para cadastrar os contatos como leads.',
    status: { uploaded: 'Não iniciada', queued: 'Na fila', processing: 'Processando', completed: 'Concluída', failed: 'Falhou' },
    columns: { file: 'Arquivo', status: 'Situação', rows: 'Linhas', created: 'Novos leads', updated: 'Atualizados', existing: 'Já existiam', review: 'Revisar', rejected: 'Rejeitados', date: 'Data' },
    rejectedCsv: 'Rejeitadas (CSV)',
    reviewCsv: 'Revisar (CSV)',
    existingCustomerCsv: 'Já clientes (CSV)',
  },
  optoutsPage: {
    title: 'Descadastros',
    subtitle: 'Quem pediu para não receber mais, de qual campanha saiu e como trazer de volta: um link para o próprio contato confirmar.',
  },
  optouts: {
    title: 'Descadastros',
    originNone: 'Sem campanha',
    linkIssuedAt: 'Link enviado em {when}',
    requestLink: 'Enviar link',
    linkTitle: 'Link para voltar a receber',
    linkText: 'O contato abre o link e confirma num botão que quer voltar a receber. Só ele traz o endereço de volta. O link vale por 30 dias. Endereço: {address}',
    linkWhatsapp: 'Para WhatsApp, copie o link e envie pela conversa com o contato.',
    linkComplaint: 'Quem marcou o e-mail como spam não recebe nada daqui. Copie o link e envie por outro meio, se o contato pediu.',
    linkCopy: 'Copiar link',
    linkSend: 'Enviar por e-mail',
    linkSent: 'Link enviado para {address}.',
    linkCopied: 'Link copiado.',
    add: 'Registrar descadastro',
    all: 'Todos',
    added: 'Descadastro registrado.',
    active: 'Em vigor',
    lifted: 'Revertido',
    liftedAt: 'revertido em {when}',
    emptyTitle: 'Nenhum descadastro',
    emptyText: 'Quem pedir para sair, pelo link do e-mail ou respondendo SAIR no WhatsApp, aparece aqui e nunca mais recebe por esse canal.',
    columns: { address: 'Endereço', channel: 'Canal', origin: 'Campanha', source: 'Como pediu', date: 'Data', status: 'Situação' },
    source: { email_link: 'Link do e-mail', whats_app_keyword: 'Palavra no WhatsApp', whatsapp_keyword: 'Palavra no WhatsApp', manual: 'Registro manual', complaint: 'Denúncia de spam' },
    resubscribe: 'Voltar a enviar',
    resubscribeTitle: 'Voltar a enviar para este endereço',
    resubscribeText: 'Só é possível se o próprio contato pediu para voltar a receber. A confirmação fica na auditoria. Endereço: {address}',
    contactAsked: 'O contato pediu para voltar a receber mensagens',
    resubscribed: 'Envio reativado para o endereço.',
  },
  exports: {
    title: 'Exportações',
    subtitle: 'Um arquivo com um envio por linha e seus status. É gerado em segundo plano e um aviso chega pelo sino quando ficar pronto.',
    new: 'Nova exportação',
    campaign: 'Campanha',
    flow: 'Fluxo',
    anyCampaign: 'Todas as campanhas',
    anyFlow: 'Todos os fluxos',
    format: 'Formato',
    from: 'De',
    to: 'Até',
    privacy: 'O arquivo contém dados pessoais: fica disponível por alguns dias, só para quem pediu (e administradores), e cada pedido e download fica na auditoria.',
    request: 'Gerar arquivo',
    requested: 'Exportação pedida. Avisaremos quando estiver pronta.',
    history: 'Exportações pedidas',
    empty: 'Nenhuma exportação ainda.',
    download: 'Baixar',
    truncated: 'Parcial',
    status: { queued: 'Na fila', processing: 'Gerando', ready: 'Pronta', failed: 'Falhou', expired: 'Expirada' },
    columns: { requested: 'Pedida em', status: 'Situação', format: 'Formato', rows: 'Linhas', size: 'Tamanho', expires: 'Expira em', by: 'Pedida por' },
  },
  sends: {
    title: 'Envios da campanha',
    hint: 'Cada mensagem e a situação dela agora. Clique num número para filtrar e numa linha para ver tudo o que aconteceu com aquela mensagem. A tela se atualiza sozinha.',
    all: 'Todos',
    filter: 'Filtrar pela situação',
    search: 'Buscar envios',
    searchHint: 'Nome, empresa ou endereço',
    none: 'Nenhum envio ainda',
    noneText: 'As mensagens aparecem aqui quando os contatos entram no fluxo e a primeira etapa de envio roda.',
    noneFiltered: 'Nenhum envio com esse filtro',
    more: 'Ver mais ({shown} de {total})',
    attempts: 'Tentativas de envio: {n}',
    sender: 'enviado como {name}',
    columns: { contact: 'Contato', company: 'Empresa', situation: 'Situação', address: 'Endereço', step: 'Etapa', queued: 'Entrou na fila', channel: 'Canal', reason: 'Motivo' },
    situation: {
      queued: 'Na fila',
      sent: 'Enviado',
      delayed: 'Atrasado',
      delivered: 'Entregue',
      opened: 'Aberto',
      clicked: 'Clicado',
      replied: 'Respondido',
      failed: 'Falhou',
      provider_suppressed: 'Recusado pelo provedor',
      blocked: 'Bloqueado',
      cancelled: 'Cancelado',
    },
    help: {
      queued: 'Esperando a vez de sair (limites, horário ou nova tentativa).',
      sent: 'O provedor aceitou e está entregando. Ainda sem confirmação de entrega.',
      delayed: 'O provedor avisou que a entrega está atrasada (problema temporário no servidor do destinatário). Ele continua tentando.',
      delivered: 'A mensagem chegou ao servidor do destinatário.',
      opened: 'O destinatário abriu a mensagem.',
      clicked: 'O destinatário clicou em um link.',
      replied: 'O destinatário respondeu.',
      failed: 'Não saiu ou foi devolvida (endereço inexistente, caixa cheia, erro do provedor).',
      provider_suppressed: 'O provedor não envia para este endereço (ele está na lista de supressão do provedor, por devolução ou denúncia anteriores).',
      blocked: 'Barrada antes de enviar: descadastro, sem endereço ou limite de frequência.',
      cancelled: 'Descartada porque a campanha foi pausada ou encerrada.',
    },
    kind: {
      queued: 'Entrou na fila',
      accepted: 'Aceito pelo provedor',
      sent: 'Enviado pelo provedor',
      scheduled: 'Agendado no provedor',
      delivered: 'Entregue',
      delivery_delayed: 'Entrega atrasada',
      opened: 'Aberto',
      read: 'Lido',
      clicked: 'Clicou',
      replied: 'Respondeu',
      auto_reply: 'Resposta automática',
      bounced: 'Devolvido',
      failed: 'Falhou',
      suppressed: 'Recusado pelo provedor',
      blocked: 'Bloqueado',
      complained: 'Marcado como spam',
      opt_out: 'Descadastrou',
    },
  },
  mailWebhook: {
    title: 'Entregas, aberturas e cliques',
    hint: 'Para saber quem recebeu, abriu e clicou, o provedor de e-mail avisa a plataforma por um endereço (webhook). Cadastre o endereço abaixo no painel do provedor e cole aqui a chave de assinatura que ele mostra.',
    noSender: 'Configure primeiro a conta de e-mail da empresa (Configurações › E-mail). Sem ela não há onde guardar a chave.',
    urlLabel: 'Endereço do webhook',
    copy: 'Copiar',
    copied: 'Endereço copiado.',
    noUrl: 'O endereço público da plataforma não está configurado. Fale com o suporte.',
    secret: 'Chave de assinatura (whsec_…)',
    secretHint: 'Aparece no painel do provedor, na página do webhook. É guardada cifrada e nunca volta para esta tela.',
    save: 'Salvar chave',
    replace: 'Trocar chave',
    remove: 'Remover chave',
    removeTitle: 'Remover a chave do webhook?',
    removeText: 'As entregas, aberturas e cliques deixam de ser registrados até uma nova chave ser salva.',
    saved: 'Chave salva. Agora falta chegar o primeiro evento.',
    removed: 'Chave removida.',
    fix: 'Revise o campo destacado.',
    waitingKey: 'Falta a chave',
    waitingEvent: 'Aguardando o primeiro evento',
    receiving: 'Recebendo eventos',
    lastEvent: 'Último: {kind}, {when}',
    waitingHint: 'Mande uma campanha para você mesmo e abra o e-mail. Quando o primeiro evento chegar, este aviso muda sozinho.',
    kinds: {
      delivered: 'entregue',
      opened: 'aberto',
      clicked: 'clicado',
      bounced: 'devolvido',
      complained: 'marcado como spam',
    },
    howTitle: 'Como cadastrar no provedor (Resend)',
    how: {
      1: 'No painel do provedor, abra o domínio de envio e ligue o rastreamento de abertura (Open tracking) e de cliques (Click tracking). Sem isso o provedor não gera esses eventos.',
      2: 'Em Webhooks, crie um webhook e cole o endereço acima.',
      3: 'Marque os eventos: email.delivered, email.opened, email.clicked, email.bounced e email.complained.',
      4: 'Salve e copie a chave de assinatura (começa com whsec_) que o provedor mostra.',
      5: 'Cole a chave aqui e salve.',
    },
  },
  mailbox: {
    title: 'Respostas por e-mail (Google Workspace)',
    hint: 'Para saber quem respondeu, a plataforma lê as respostas na caixa de quem enviou o e-mail. A empresa autoriza uma vez uma conta de serviço do próprio Google Cloud; todo colaborador com e-mail do domínio passa a valer, sem cadastro por pessoa.',
    saveConnection: 'Salvar conexão',
    domain: 'Domínio do Workspace',
    domainHint: 'O domínio dos e-mails de quem envia (por exemplo, empresa.com.br).',
    key: 'Chave da conta de serviço (JSON)',
    keyHint: 'Cole o conteúdo do arquivo .json baixado do Google Cloud. A chave é guardada cifrada e nunca volta para esta tela.',
    keyKeep: 'Deixe em branco para manter a chave atual.',
    saved: 'Conexão salva. Falta testar com uma caixa de verdade.',
    fix: 'Revise os campos destacados.',
    on: 'Lendo as respostas',
    untested: 'Falta testar',
    error: 'Com erro',
    lastRead: 'Última leitura: {when}',
    testHint: 'Teste com o e-mail de uma pessoa de {domain}: a plataforma lê só o perfil da caixa, nenhuma mensagem. Ao funcionar, a leitura das respostas é ligada.',
    mailbox: 'E-mail de uma pessoa do domínio',
    testOk: 'Funcionou. As respostas passam a ser lidas.',
    testFailed: 'O teste não passou. Veja o motivo acima.',
    testing: 'Testando…',
    stuck: 'O serviço de e-mail ainda não respondeu ao teste. Confira se o processo que lê as respostas (o Worker do e-mail) está rodando.',
    remove: 'Remover conexão',
    removeTitle: 'Remover a conexão com o Google Workspace?',
    removeText: 'A plataforma deixa de ler as respostas. O que já foi lido continua nas campanhas.',
    removed: 'Conexão removida.',
    howTitle: 'Como autorizar no Google (feito uma vez, por quem administra o Workspace)',
    how: {
      1: 'No Google Cloud da empresa, crie uma conta de serviço e ative a Gmail API no projeto.',
      2: 'Na conta de serviço, crie uma chave do tipo JSON e cole o conteúdo acima.',
      3: 'Copie o "ID do cliente" (número) da conta de serviço.',
      4: 'Em admin.google.com › Segurança › Controle de acesso e de dados › Controles de API › Delegação em todo o domínio, adicione esse ID com o escopo abaixo.',
      5: 'Volte aqui, salve e teste com o e-mail de uma pessoa. A autorização do Google pode levar alguns minutos.',
    },
    privacy: 'A leitura é só de leitura e só procura as mensagens dirigidas ao endereço de acompanhamento de cada e-mail enviado pela plataforma (um endereço da própria pessoa com uma marca, como ana+m123 no domínio da empresa). A plataforma não lista nem lê o resto da caixa.',
  },
  settings: {
    title: 'Configurações dos envios',
    subtitle: 'Canais, limites e proteções. O e-mail sai pelo remetente da empresa; o WhatsApp, pelo número da empresa.',
    saved: 'Configurações salvas.',
    saveLimits: 'Salvar limites e proteções',
    email: 'E-mail',
    emailHint: 'Testa a conta de envio da empresa sem mandar nenhum e-mail: a chave, o limite por segundo, a cota e os registros do domínio (SPF, DKIM e DMARC).',
    testConnection: 'Testar conexão',
    ready: 'Pronto para enviar',
    notReady: 'Não está pronto',
    rate: 'Limite do provedor: {n} por segundo',
    quotaUsed: 'Cota usada: {day} hoje, {month} no mês',
    missing: 'ausente',
    dailyLimit: 'Limite diário de e-mails',
    monthlyLimit: 'Limite mensal de e-mails',
    limitHint: 'O do plano de e-mail da empresa. As campanhas pausam sozinhas ao chegar a 100% e voltam quando o dia ou o mês virar.',
    whatsapp: 'WhatsApp',
    whatsappHint: 'O marketing por WhatsApp é uma decisão da empresa: ligado, as campanhas podem usar o número conectado.',
    marketingOn: 'Marketing por WhatsApp',
    marketingHint: 'Desligar pausa na hora as campanhas de WhatsApp e cancela o que estava na fila.',
    testNumber: 'Testar número',
    numberReady: 'Número conectado',
    provider: 'Provedor: {name}',
    providers: { meta_cloud: 'API oficial (Meta)', meta: 'API oficial (Meta)', z_api: 'Z-API', zapi: 'Z-API', wafly: 'Wafly', wpp_connect: 'WPPConnect' },
    needsTemplates: 'usa modelos aprovados pela Meta',
    perMinute: 'Mensagens por minuto',
    protection: 'Proteções',
    failureRate: 'Pausar quando falhar (%)',
    failureRateHint: 'Acima deste percentual de falhas em um disparo, a campanha pausa e a equipe é avisada.',
    failureSample: 'Mínimo de envios para avaliar',
    frequencyMax: 'Máximo de mensagens por contato',
    frequencyHint: 'Em branco = sem limite. Vale por canal, na janela de dias ao lado.',
    frequencyDays: 'A cada quantos dias',
    frequencyBehavior: 'Quando passar do limite',
    behavior: { defer: 'Adiar o envio', suppress: 'Não enviar' },
  },
}
